import TCanvas from "@common/canvas/TCanvas";
import Sidebar from "@common/components/Navigation/SideBar";
import PageBuilder from "@common/general/PageBuilder";
import { useStore } from "@state/store";
import gsap from "gsap";
import { useEffect, useRef } from "react";
import styled from "styled-components/macro";
import TCanvas_OPT from "@common/canvas/TCanvas_optimised";
import { Vector3 } from "three";

export const camTarget = new Vector3(0, 0.4, 0);

const SidebarLayout = () => {
  const appWrapperRef = useRef<HTMLDivElement>(null);

  const navigation = useStore((s) => s.navigation);

  useEffect(() => {
    if (navigation) {
      gsap.to(appWrapperRef.current, {
        opacity: 0,
        duration: 0.5,
        ease: "power3.inOut",
      });
    } else {
      gsap.to(appWrapperRef.current, {
        opacity: 1,
        duration: 0.5,
        delay: 0.26,
        ease: "power3.inOut",
      });
    }
  }, [navigation]);

  // const isFull3D = import.meta.env.VITE_ROOT_BUILD === "london";
  const isFull3D = false;

  return (
    <SidebarLayoutWrapper>
      <SidebarLayoutNavWr>
        <Sidebar />
      </SidebarLayoutNavWr>
      <SidebarLayoutContentWr ref={appWrapperRef}>
        <PageBuilder />
        {isFull3D ? <TCanvas /> : <TCanvas_OPT />}
      </SidebarLayoutContentWr>
      <div className="splashAnim"></div>
    </SidebarLayoutWrapper>
  );
};

export default SidebarLayout;

const SidebarLayoutWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  background-color: #2c1c1d;

  .splashAnim {
    opacity: 0;
    pointer-events: none;
    position: fixed;
    z-index: 100;
    width: 100%;
    height: 100%;
    background-color: var(--primary);
  }
`;

const SidebarLayoutNavWr = styled.nav`
  position: relative;
  height: 100%;
  width: 15%;
  pointer-events: none;
`;

const SidebarLayoutContentWr = styled.main`
  position: relative;
  width: 85%;
  height: 100%;
  z-index: 3;
`;
